/**
 * CR-7321: Admin Setup > Purchasing — "Price Book Types & Sharing".
 *
 * Merges what used to be two adjacent sections — "Manage Contract Types" and
 * "Price Book Sharing" — into one card, because they are one thing: the types
 * configured at the top ARE the price book types the sharing controls below
 * share. The types table sits above the sharing controls, in that order,
 * because you configure the types before choosing which to share.
 *
 * This is a copy/merge on the admin screen only. The underlying entity is
 * unchanged — the model, table, API and the `ContractType` class all keep
 * their names, and the supplier Contracts register still says "Contract Type"
 * (it lists actual contracts, which is a different thing). No backend change.
 */
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { BookOpen } from 'lucide-react';
import { ContractTypesSection } from './ContractTypesSection';
import { PriceBookSharingSection } from './PriceBookSharingSection';

export function PriceBookTypesAndSharingSection() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <BookOpen className="h-5 w-5" />
          Price Book Types &amp; Sharing
        </CardTitle>
        <p className="text-sm text-muted-foreground mt-1">
          Configure your price book types, then choose which of them your suppliers can view.
        </p>
      </CardHeader>
      <CardContent className="space-y-8">
        <ContractTypesSection embedded />
        <PriceBookSharingSection embedded />
      </CardContent>
    </Card>
  );
}
